import { forwardRef } from 'react';
import { CardContentContainer } from './styled.js';
import { jsx } from 'react/jsx-runtime';

var CardContent = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
    className = props.className,
    _props$disablePadding = props.disablePadding,
    disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding;
  return /*#__PURE__*/jsx(CardContentContainer, {
    className: className,
    ref: forwardedRef,
    $noPadding: disablePadding,
    children: children
  });
});

export { CardContent };
